import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'sonner';
import './App.css';

import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ApproachSection from './components/ApproachSection';
import PortfolioSection from './components/PortfolioSection';
import WhyUsSection from './components/WhyUsSection';
import ContactSection from './components/ContactSection';
import LegalSection from './components/LegalSection';
import Footer from './components/Footer';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Toaster 
          position="top-right" 
          toastOptions={{
            style: {
              background: 'var(--bg-card)',
              color: 'var(--text-primary)',
              border: '1px solid var(--border-subtle)'
            }
          }}
        />
        <Header />
        <main>
          <HeroSection />
          <AboutSection />
          <ApproachSection />
          <PortfolioSection />
          <WhyUsSection />
          <ContactSection />
          <LegalSection />
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
